import React, { useState } from "react";
import api from "../../api/axiosClient";
import Footer from '../../components/Footer';

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    try {
      const response = await api.post("/Auth/Login", {
        username: username.toLowerCase(),
        password,
      });

  const { token, fullName, role, makeupArtistId, makeupArtistName, makeupArtist, forcePasswordChange } = response.data || {};

  localStorage.setItem("token", token);
  localStorage.setItem("role", role);
  localStorage.setItem("user", fullName);
  if (typeof forcePasswordChange !== 'undefined') {
    localStorage.setItem('forcePasswordChange', String(!!forcePasswordChange));
  } else {
    // default to false if backend doesn't provide yet
    localStorage.removeItem('forcePasswordChange');
  }
  if (makeupArtistId) localStorage.setItem("makeupArtistId", String(makeupArtistId));
  if (makeupArtistName) localStorage.setItem("makeupArtistName", makeupArtistName);
  if (!makeupArtistName && makeupArtist?.displayName) localStorage.setItem("makeupArtistName", makeupArtist.displayName);

      if (forcePasswordChange) {
        window.location.href = "/auth/force-change-password";
        return;
      }

      if (role === "Admin") {
        window.location.href = "/admin/dashboard";
      } else {
        window.location.href = "/artist/dashboard";
      }

    } catch (err: any) {
      const msg = err?.response?.data || err?.message || "Login failed";
      setError(String(msg));
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-background pb-16">
      <div className="card border border-secondary/20 rounded-2xl bg-white p-8 w-full max-w-md shadow-lg">
        <h2 className="text-3xl font-semibold text-center mb-8 text-primary font-sans tracking-tight">Login</h2>

        {error && (
          <div className="bg-red-100 text-red-600 p-2 mb-4 rounded">{error}</div>
        )}

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-secondary mb-1">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full border border-secondary/30 rounded-xl px-3 py-2 bg-background focus:border-primary focus:ring-2 focus:ring-primary/30 outline-none transition"
              placeholder="Enter your username"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-secondary mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-secondary/30 rounded-xl px-3 py-2 bg-background focus:border-primary focus:ring-2 focus:ring-primary/30 outline-none transition"
              placeholder="Enter your password"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full btn-primary mt-2"
          >
            Login
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
}
